import { dataAnticlockwise } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAnticlockwise = /*#__PURE__*/createIcon(dataAnticlockwise)
export default IconAnticlockwise
